import * as Yup from 'yup';
import { AddressValidationErrors, addressValidator, ChangeAddressData } from 'cpes-common';
import { useTranslation } from 'react-i18next';

export const useAddressValidationSchema = (): Yup.SchemaOf<ChangeAddressData> => {
    const { t } = useTranslation('my-profile-address-details');
    const required = (label: string): string => t('edit-view.validations.required', { label });
    const defaultMaxMessage = (count: number): string => t('edit-view.validations.invalid-count', { count });
    const matches = (label: string): string => t('edit-view.validations.invalid-pattern', { label });
    const messages: AddressValidationErrors = {
        street: {
            name: {
                required: required(t('edit-view.street.name.label')),
                max: defaultMaxMessage(30),
                matches: matches(t('edit-view.street.name.label')),
            },
            number: {
                required: t('edit-view.street.number.validations.required'),
                max: defaultMaxMessage(4),
                matches: matches(t('edit-view.street.number.label')),
            },
        },
        complementaryInformation: {
            block: {
                max: defaultMaxMessage(4),
                matches: matches(t('edit-view.complementary-information.block')),
            },
            stairs: {
                max: defaultMaxMessage(4),
                matches: matches(t('edit-view.complementary-information.block')),
            },
            floor: {
                max: defaultMaxMessage(4),
                matches: matches(t('edit-view.complementary-information.block')),
            },
            door: {
                max: defaultMaxMessage(4),
                matches: matches(t('edit-view.complementary-information.block')),
            },
            details: {
                max: defaultMaxMessage(40),
                matches: matches(t('edit-view.complementary-information.block')),
            },
        },
        city: {
            locality: {
                required: required(t('edit-view.city.locality.label')),
                max: defaultMaxMessage(26),
                matches: matches(t('edit-view.city.locality.label')),
            },
            zip: {
                required: required(t('edit-view.city.zip.label')),
                max: defaultMaxMessage(5),
                matches: t('edit-view.city.zip.validations.invalid-pattern'),
            },
        },
    };
    return addressValidator(messages);
};
